import React, { PureComponent } from 'react';
import axios from 'axios';
import { onlyUniqueFromArray } from 'wt-react/dist/util/functions.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faCircleNotch,
  faChevronDown,
  faChevronUp,
  faCaretDown,
  faCopy,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FundFrame from '../FundFrame/FundFrame.js';
import './App.css';

// Import an example fund
// import exampleFunds from '../../examplefund.json';

// Set up Font Awesome
library.add(faStar, faCircleNotch, faChevronDown, faChevronUp, faCaretDown, faCopy);

class App extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      funds: null,
      waiting: true,
      initialFund: null,
    };
  }

  componentDidMount() {
    this.getFundData(this.props.params);

    const hashValues = window.location.hash.substring(1).split('?')[0].split('_');

    this.setState({
      initialFund: hashValues && hashValues.length > 0 && hashValues[0] ? hashValues[0].toLowerCase() : null,
    });

  }

  // Handle close of modal
  handleCloseModal() {

    this.setState({
      openModal: false,
    });

  }

  render() {

    const {
      params,
    } = this.props;


    const {
      funds,
      waiting,
    } = this.state;

    // Set up the fund cards
    let fundOutput;
    if (funds) {

      fundOutput =
        <FundFrame
          funds={funds}
          params={params}
        />;

    } else if (waiting) {
      fundOutput =
        <div className='waiting'>
          <FontAwesomeIcon icon="circle-notch" size="3x" className="waiting-icon" spin />
        </div>;
    }

    return (
      <div className="app">

        {fundOutput}

      </div>
    );
  }

  // Get a string list of tickers for sending to DataSpan
  getTickerString(fund){

    const tickers = [];

    tickers.push(fund.ticker);

    // If there are benchmarks then get those too
    if (fund.benchmarkTickers) {
      fund.benchmarkTickers.forEach(benchmark => {
        tickers.push(benchmark);
      });
    }

    // Remove any duplicates
    const deDupedTickers = onlyUniqueFromArray(tickers);

    // Write out the tickers array to a string
    let tickersText = '';
    deDupedTickers.forEach(ticker => {
      tickersText = `${tickersText},${ticker}`;
    });

    return tickersText;

  }

  // Get the Fund Data for the app
  async getFundData(params) {

    const funds = JSON.parse(JSON.stringify(params.funds));
    const outputFunds = [];

    // Loop over the top level groups, then families, then tickers in each family
    for (const fund of funds){

      const tickersText = this.getTickerString(fund);

      const request = {
        method: 'GET',
        url: `${params.dataspanApiUrl}/fundhighlights/data/`,
        params: {
          tickers: tickersText,
        },
      };

      try {

        // Get the fund data from dataspan
        const response = await axios(request);

        // Set up the data
        const matchFund = response.data.filter(elem => fund.ticker === elem.ticker);
        fund.data = [];

        // If a match is found then add the data element
        if (matchFund.length > 0) {
          fund.data.push(matchFund[0]);
        }

        // Find the benchmark data and add it
        if (fund.benchmarkTickers && fund.data) {

          fund.benchmarkTickers.forEach(benchmark => {
            const matchBenchmark = response.data.filter(elem => benchmark === elem.ticker);

            if (matchBenchmark.length > 0) {
              fund.data.push(matchBenchmark[0]);
            }
          });
        }

        // Save output fund with data
        outputFunds.push(fund);

      } catch (e) {

        if (e.response.status === 404) {
          // Remove the waiting circle
          this.setState({ waiting: false });
        }
        console.log(e);
      }

    }

    // Save the data to state
    this.setState({
      funds: outputFunds,
      waiting: false,
    });



  }

}

export default (App);
